import React from 'react';

import { Button } from '../../../components/general';

interface Props {
  children: React.ReactNode;
  onClick: (e: React.MouseEvent<HTMLElement>) => void;
}

const UploadMoreBtn: React.FC<Props> = (props) => {
  const { children, onClick } = props;

  return (
    <Button
      onClick={onClick}
      colour="pink"
      className="w-full sm:w-1/2 font-bold"
    >
      {children}
    </Button>
  );
};

export default UploadMoreBtn;
